module.exports = __webpack_public_path__ + "img/tjfoot.c7a467bd.jpg";